<template>
    <div>
        <div class="card" :style="{background:bgColor}" v-for="(item,index) in list" :key="index">
            <div class="cardTitle">{{ item.name }}</div>
            <div class="cardMain">
                <div v-if="getServiceImage(item)" class="serviceThumb">
                    <img :src="getServiceImage(item)" :alt="item.name || 'Service'" />
                </div>
                <div class="cardInfo">
                    <div class="cardContent descContent" :class="{'expanded': expandedItems[index]}" v-html="stripDescriptionBg(item.content)" :ref="'content_' + index"></div>
                    <div class="expandBtn" v-if="overflowItems[index]" @click.stop="toggleExpand(index)">...</div>
                </div>
            </div>
            <div class="cardBottom">
                <div class="cardPrice">
                    <div class="Price">${{ item.price }}</div>
                    <div v-if="shouldShowOriginalPrice(item)" class="originalPrice">${{ getOriginalPriceLabel(item) }}</div>
                    <div v-if="getDurationLabel(item)" class="time">{{ getDurationLabel(item) }}</div>
                </div>
                <div class="bookingBtn" @click="handleShow(item,index)">Book</div>
            </div>
        </div>
        <van-popup
            v-model="show"
            closeable
            round
            close-icon-position="top-right"
            position="bottom"
            :style="{ height: 'auto',padding:'1rem',boxSizing:'border-box',display:'flex',flexDirection: 'column',
    justifyContent:'space-between' }"
            >
            <div style="color:#333333;">Service Details</div>
            <div v-if="showData.image && showData.image.length > 0 " class="imageBox">
                <van-image
                    v-for="(item,index) in showData.image"
                    :key="index"
                    width="100"
                    height="100"
                    :src="getUrl(item.file_path)"
                />
            </div>
            <div>{{ showData.name }}</div>
            <div class="descContent" style="margin:0.5rem 0" v-html="stripDescriptionBg(showData.content)"></div>
            <div class="cardPrice">
                <div class="Price">${{showData.price}}</div>
                <div v-if="shouldShowOriginalPrice(showData)" class="originalPrice">${{ getOriginalPriceLabel(showData) }}</div>
                <div v-if="getDurationLabel(showData)" class="time">{{ getDurationLabel(showData) }}</div>
            </div>
            <div class="bookingBtn" @click="handleBooking(showData)">Book</div>
        </van-popup>
    </div>
</template>
<script>
import myMixin from '@/utils/myMixin';
import { ensureLoggedInOrPrompt } from '@/utils/authGuard'
export default {
    name:'HomeCard',
    props:{
        shopkey:{
            type:String,
            default:'Message'
        },
        isPopup:{
            type:Boolean,
            default:false,
        },
        bgColor:{
            type:String,
            default:'#F4F4F4'
        },
        list:{
            type:Array,
            default:()=>{
                return []
            }
        }
    },
    mixins: [myMixin],
    data(){
        return {
            show:false,
            showData:{},
            expandedItems:{},
            overflowItems:{}
        }
    },
    mounted(){
        this.$nextTick(() => {
            this.checkOverflow()
        })
    },
    watch:{
        list:{
            handler(){
                this.$nextTick(() => {
                    this.checkOverflow()
                })
            },
            deep:true
        }
    },
    methods:{
        checkOverflow(){
            this.list.forEach((item, index) => {
                const el = this.$refs['content_' + index]
                if(el && el[0]){
                    const element = el[0]
                    const lineHeight = parseFloat(getComputedStyle(element).lineHeight) || 18
                    const maxHeight = lineHeight * 2
                    this.$set(this.overflowItems, index, element.scrollHeight > maxHeight + 2)
                }
            })
        },
        toggleExpand(index){
            this.$set(this.expandedItems, index, !this.expandedItems[index])
        },
        getServiceImage(item){
            const image = item && item.image
            if(Array.isArray(image) && image.length > 0){
                return this.getUrl(image[0])
            }
            if(image){
                return this.getUrl(image)
            }
            return ''
        },
        stripDescriptionBg(html){
            if(!html) return ''
            return String(html).replace(/\sstyle=(['"])(.*?)\1/gi, (full, quote, styleText) => {
                const cleaned = String(styleText)
                    .replace(/(^|;)\s*background(?:-color)?\s*:[^;]*;?/gi, '$1')
                    .replace(/;;+/g, ';')
                    .replace(/^\s*;|;\s*$/g, '')
                    .trim()
                return cleaned ? ` style=${quote}${cleaned}${quote}` : ''
            })
        },
        normalizePrice(value){
            if(value === '' || value === null || typeof value === 'undefined') return null
            const num = Number(value)
            return Number.isFinite(num) ? num : null
        },
        shouldShowOriginalPrice(item){
            const originalPrice = this.normalizePrice(item && item.originalPrice)
            const currentPrice = this.normalizePrice(item && item.price)
            if(originalPrice === null || originalPrice <= 0) return false
            if(currentPrice !== null && originalPrice === currentPrice) return false
            return true
        },
        getOriginalPriceLabel(item){
            return item && item.originalPrice
        },
        getDurationLabel(item){
            if(!item) return ''
            const rawHour = item.hour
            const rawMinute = item.minute
            const hasHour = rawHour !== '' && rawHour !== null && typeof rawHour !== 'undefined'
            const hasMinute = rawMinute !== '' && rawMinute !== null && typeof rawMinute !== 'undefined'
            const hour = Number(rawHour) || 0
            const minute = Number(rawMinute) || 0

            if(hour > 0){
                return minute > 0 ? `${hour}h ${minute}min` : `${hour}h`
            }
            if(minute > 0 || hasMinute){
                return `${minute}min`
            }
            if(hasHour){
                return `${hour}h`
            }
            return ''
        },
        handleShow(item){
            if( this.isPopup ){
                this.$bus.$emit('closePopup', {...item})
            }else{
                this.show = true
                this.showData = {...item}
            }
        },
        handleBooking(){
            ensureLoggedInOrPrompt(this.$route && this.$route.fullPath).then(ok => {
                if (!ok) return
                this.$router.push({path:'/booking',query:{shopkey:this.shopkey,data:JSON.stringify(this.showData)}})
            })
        }
    }
}
</script>
<style lang="scss" scoped>
    ::v-deep .descContent *{
        font-size: inherit !important;
        font-family: inherit !important;
        font-weight: inherit !important;
        font-style: inherit !important;
        color: inherit !important;
        line-height: inherit !important;
        background: transparent !important;
        background-color: transparent !important;
    }
    .imageBox{
        display: flex;
        align-items: center;
        overflow: auto;
        gap: 0.5rem;
        margin: 0.5rem 0;
        div{
            flex-shrink: 0;
        }
    }
    .cardPrice{
        display: flex;
        align-items: center;
        gap: 0.5rem;
        margin-bottom: 0.5rem;
    }
        .Price{
        font-size: 1rem;
        color: #333333;
    }
    .originalPrice{
        font-size: .75rem;
        text-decoration: line-through;
    }
    .time{
        font-size: .875rem;
        color: #666666;
    }
    .bookingBtn{
        width: 100%;
        height: 2.25rem;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        background: #1E3C3E;
        border-radius: .25rem;
        box-sizing: border-box;
    }
    .card{
        width: 100%;
        height: auto;
        margin-bottom: 1rem;
        border-radius: .25rem;
        padding: 1rem;
        box-sizing: border-box;
        &:last-child{
            margin-bottom: 0;
        }
        .cardMain{
            display: flex;
            align-items: flex-start;
            gap: .75rem;
            margin-bottom: .75rem;
            margin-top: 0.5rem;
        }
        .serviceThumb{
            flex: 0 0 4rem;
            width: 4rem;
            height: 4rem;
            margin-top: .575rem;
            border-radius: .25rem;
            overflow: hidden;
            background: #ECEFED;
            img{
                width: 100%;
                height: 100%;
                object-fit: cover;
                display: block;
            }
        }
        .cardInfo{
            flex: 1;
            min-width: 0;
        }
        .cardTitle{
            font-size: 1rem;
            font-weight: 700;
            color: #1a1a1a;
        }
        .cardContent{
            color: #666666;
            font-size: .75rem;
            margin: 0;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-word;
            &.expanded{
                -webkit-line-clamp: unset;
                display: block;
            }
        }
        .expandBtn{
            color: #666666;
            font-size: 1rem;
            font-weight: bold;
            cursor: pointer;
            margin: 0.25rem 0 0.5rem 0;
            line-height: 1;
            background: #DAEBE5;
            border-radius: 0.25rem;
            padding: 0.1rem 0.5rem 0.5rem 0.5rem;
            width: fit-content;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .cardBottom{
            display: flex;
            align-items: center;
            justify-content: space-between;
            .cardPrice{
                display: flex;
                align-items: center;
                gap: 0.5rem;
                .Price{
                    font-size: 1rem;
                    color: #333333;
                }
                .originalPrice{
                    font-size: .75rem;
                    text-decoration: line-through;
                }
                .time{
                    font-size: .875rem;
                    color: #666666;
                }
            }
            .bookingBtn{
                width: fit-content;
                height: 2.25rem;
                padding: 0 1rem;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #fff;
                background: #1E3C3E;
                border-radius: .25rem;
                box-sizing: border-box;
            }
        }
    }
</style>
